import { Link } from "react-router";
import { HorizontalSequence } from "../components/portfolio/ScrollPortfolio";
import { getAllImages, portfolios } from "../lib/portfolios";

export function meta() {
  return [{ title: "Photos — Captures by Mari" }];
}

export default function WorkIndex() {
  const images = getAllImages();
  return (
    <main>
      <header className="work-opening"><h1>Photographs</h1><p>{images.length} photographs</p></header>
      <HorizontalSequence images={images} title="Soccer & track" id="collection" />
      <nav className="work-series" aria-label="Photo series">
        {portfolios.map((portfolio) => <Link key={portfolio.slug} to={`/work/${portfolio.discipline}/${portfolio.slug}`}><h2>{portfolio.title}</h2><span>{portfolio.images.length} photos ↗</span></Link>)}
      </nav>
    </main>
  );
}
